import gdnLogo from '../../assets/gdn-logo.jpeg';

export default function GlobalFooter() {
  return (
    <footer className="fixed bottom-0 left-[240px] right-0 z-30 hidden h-8 border-t border-border bg-surface px-4 text-[11px] text-zinc-400 lg:block">
      <div className="flex h-full items-center justify-between">
        <div className="flex items-center gap-2">
          <img src={gdnLogo} alt="GDN Corp" className="h-[18px] w-auto rounded-sm bg-[#0f172a] object-contain p-[1px]" />
          <span>GDN Corp © 2026</span>
        </div>
        <span>MecSync v1.0.0</span>
        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-1 xl:flex">
            <img src="/synes-ia-logo-transparent.png" alt="Synes.ia" className="h-[18px] w-auto rounded-sm object-contain p-[1px]" />
            Premium IA
          </span>
          <a href="mailto:contato@gdncorp.com.br" className="hover:text-sky-400">Suporte</a>
          <a href="/configuracoes/sobre" className="hover:text-sky-400">Sobre</a>
        </div>
      </div>
    </footer>
  );
}

